<template>
    <div class="content">
        <div class="content-head" v-if="showQuery">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="收货地址">
                    <el-select v-model="params.Orders_Address_Country" placeholder="请选择国家" class="el-select-mini">
                        <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN"
                            :value="item.Country_Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_Province" placeholder="请选择省" class="el-select-mini"
                        @change="provinceChange" clearable filterable>
                        <el-option v-for="item in provinceList" :key="item.Code" :label="item.Name"
                            :value="item.Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_City" placeholder="请选择市/地区" class="el-select-mini"
                        @change="cityChange" clearable filterable>
                        <el-option v-for="item in cityListopt" :key="item.Code" :label="item.Name"
                            :value="item.Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_District" placeholder="请选择区/县" class="el-select-mini"
                        clearable filterable>
                        <el-option v-for="item in districtListopt" :key="item.Code" :label="item.Name"
                            :value="item.Code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同日期">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期"
                    value-format="yyyy-MM-dd" clearable></el-date-picker>
                <span style="margin: 0 5px;">至</span>
                <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期"
                    value-format="yyyy-MM-dd" clearable></el-date-picker> 
                </el-form-item>
                <el-form-item label="合同类型">
                    <el-select v-model="params.orders_tradetype" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in orders_tradetype_opt" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款方式" v-if="isFiltration">
                    <el-select v-model="params.paytype" placeholder="请选择" class="el-select-medium">
                         <el-option label="全部合同" :value="0" :title="'全部合同'">
                            <el-tooltip effect="dark" :content="'全部合同'" placement="right">
                                <span class="ellipsis-option">全部合同</span>
                            </el-tooltip>
                        </el-option>
                        <el-option v-for="item in paytype_opt" :key="item.Pay_Type_ID" :label="item.Pay_Type_Name"
                            :value="item.Pay_Type_ID">
                            <el-tooltip effect="dark" :content="item.Pay_Type_Name" placement="right">
                                <span class="ellipsis-option">{{ item.Pay_Type_Name }}</span>
                            </el-tooltip>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同纸状态" v-if="isFiltration">
                    <el-select v-model="params.RecoverStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in RecoverStatus_opt" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="BPM审核状态" v-if="isFiltration">
                    <el-select v-model="params.orders_bpmauditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in orders_bpmauditstatus_List" :key="item.value" :label="item.name"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="电子签章状态" v-if="isFiltration">
                    <el-select v-model="params.Orders_ESignStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Orders_ESignStatus_List" :key="item.value" :label="item.name"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label=" 折扣分组" v-if="isFiltration">
                    <el-select v-model="params.Orders_ESignStatus" multiple placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in []" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="业务员" v-if="isFiltration">
                    <el-input v-model="params.officeman" placeholder="请输入" clearable
                        class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="关键词" v-if="isFiltration">
                    <el-input v-model="params.keyword" style="width: 450px" placeholder="输入合同号、纸质合同号、上上签合同编号、客户名称、工程名称、收货人姓名进行搜索" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="商品名称" v-if="isFiltration">
                    <el-input v-model="params.product_name" placeholder="请输入" clearable
                        class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="原ERP订单号" v-if="isFiltration">
                    <el-input v-model="params.Orders_SourceERPSN" placeholder="请输入" clearable
                        class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getSPCOrders(true)" icon="el-icon-search"
                        :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>

            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="下单时间">
                    <el-select v-model="params.addtime" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="7天以内" :value="7"></el-option>
                        <el-option label="15天以内" :value="15"></el-option>
                        <el-option label="30天以内" :value="30"></el-option>
                    </el-select>
                    <!-- <el-radio-group v-model="params.addtime" @input="getOrders">
                        <el-radio :label="0">全部</el-radio>
                        <el-radio :label="7">7天以内</el-radio>
                        <el-radio :label="15">15天以内</el-radio>
                        <el-radio :label="30">30天以内</el-radio>
                    </el-radio-group> -->
                </el-form-item>
                <el-form-item label="合同状态">
                    <el-select v-model="params.orders_status" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="交易成功" :value="2"></el-option>
                        <el-option label="已取消" :value="3"></el-option>
                    </el-select>

                    <!-- <el-radio-group v-model="params.orders_status" @input="getOrders">
                        <el-radio-button :label="-1">全部</el-radio-button>
                        <el-radio-button :label="1">正常</el-radio-button>
                        <el-radio-button :label="2">交易成功</el-radio-button>
                        <el-radio-button :label="3">已取消</el-radio-button>
                    </el-radio-group> -->
                </el-form-item>

                <el-form-item label="审核状态">
                    <el-select v-model="params.orders_auditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="待审核" :value="1"></el-option>
                        <el-option label="已下达" :value="2"></el-option>
                        <el-option label="审核失败" :value="3"></el-option>
                    </el-select>
                    <!-- <el-radio-group v-model="params.orders_auditstatus" @input="getOrders">
                        <el-radio-button :label="-1">全部</el-radio-button>
                        <el-radio-button :label="1">待审核</el-radio-button>
                        <el-radio-button :label="2">已下达</el-radio-button>
                        <el-radio-button :label="3">审核失败</el-radio-button>
                    </el-radio-group> -->
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title" v-if="showQuery"> 
                退货申请管理
                <span>
                    <!-- <el-button type="primary" @click="getApplyOrder()">申请退货</el-button> -->
                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(1)">导出勾选合同信息</span>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(2)">导出结果合同信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :data="tableData" @selection-change="handleSelectionChange" :height="maxheight"
                ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }"
                v-loading="loadingBtn">
                <el-table-column align="center" v-if="showQuery" type="selection" width="55" fixed></el-table-column>
                <el-table-column prop="Orders_ID" label="ID" width="80" align="center" fixed></el-table-column>
                <!-- <el-table-column prop="Orders_SPCSourceName" label="来源类型" width="120" align="center" show-overflow-tooltip></el-table-column> -->
                <el-table-column prop="OfficeUserName" label="业务员" width="120" align="center"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="Orders_SN" label="合同号" align="center" width="150"></el-table-column>
                <el-table-column prop="Orders_EsignContractID" label="上上签合同编号" align="center" width="150"></el-table-column>
                <el-table-column prop="Orders_CustomerName" show-overflow-tooltip width="180" label="客户名称"
                    align="center"></el-table-column>
                <el-table-column prop="Orders_ProjectName" show-overflow-tooltip label="工程名称" align="center"
                    width="180"></el-table-column>
                <el-table-column prop="Orders_Total_AllPrice" width="120" label="合同总额" align="center">
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.Orders_Total_AllPrice }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_Status" label="合同状态" width="120" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_Status)">{{ scope.row.Orders_Status }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_ESignStatusName" width="120" label="合同审核状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_AuditStatus)">{{ scope.row.Orders_AuditStatus
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BackBillStatusName" width="120" label="BPM审核状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_BPMAuditStatus)">{{ scope.row.Orders_BPMAuditStatus
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="RecoverStatusName" width="120" label="合同纸状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_RecoverStatus)">{{ scope.row.Orders_RecoverStatus
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="BackBillSyncStatusName" width="120" label="电子签章状态" align="center">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_ESignStatusName)">{{ scope.row.Orders_ESignStatusName
                            }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_SourceType" width="150" label="来源" align="center"></el-table-column>
                <el-table-column prop="Orders_Addtime" width="150" label="下单时间" align="center">
                    <template slot-scope="scope">
                        <span>{{ scope.row.Orders_Addtime | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="120" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">查看</span>
                            <span class="operation-bar-block" v-if="scope.row.IsAppend"
                                @click="handleViewsDetail(scope.row)">追加</span>
                            <span class="operation-bar-block" v-if="scope.row.IsCopy"
                                @click="handleViewsDetail(scope.row)">复制</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog title="选择订单" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false"
            :before-close="dialogBeforeClose">
            <div>
                <el-form ref="form" label-width="120px">
                    <el-form-item label="ERP订单号">
                        <el-input v-model="Orders_SN" class="el-select-max" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" style="text-align: center">
                <el-button type="primary" @click="onNext()">下一步</el-button>
            </div>
        </el-dialog>
        <packOrderDetails :isdetails="isdetails" :id="id" @handleClose="handleClose" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import packOrderDetails from './component/packOrderDetails.vue';
import { formatDate, downloadFile } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
import { mapState } from 'vuex';
export default {
    mixins: [myMixin],
    components: {
        Pagination,
        packOrderDetails
    },
    props: {
        showQuery: {
            type: Boolean,
            default: true
        },
        projectName: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtLis
        })
    },
    data() {
        return {
            id: 272,
            isdetails: false,
            loadingBtn: false,
            dialogVisible: false,
            Orders_SN: '',
            params: {
                Orders_Address_Country: '',
                Orders_Address_District: '',
                Orders_Address_Province: '',
                Orders_Address_City: '',
                date_start: '',
                date_end: '',
                orders_tradetype: '',
                paytype: 0,
                RecoverStatus: 0,
                orders_bpmauditstatus: '',
                Orders_ESignStatus: 0,
                Orders_DiscountCate: '',
                officeman: '',
                keyword: this.showQuery?'':this.projectName,
                product_name: '',
                Orders_SourceERPSN: '',
                addtime: 0,
                orders_auditstatus: -1,
                orders_status: -1,
                Orders_SourceCate: 1
            },
            tableData: [],
            cityListopt: [],
            districtListopt: [],
            orders_tradetype_opt: [
                { label: '全部合同', value: 0 },
                { label: '销售合同', value: 1 },
                { label: '服务和物联网合同', value: 2 },
                { label: '返货合同', value: 3 }
            ],
            paytype_opt: [],
            orders_bpmauditstatus_List: [
                { name: '全部', value: 0 },
                { name: '待送审', value: 1 },
                { name: '审核中', value: 2 },
                { name: '已审核', value: 3 },
                { name: '审核失败', value: 4 },
                { name: '送审失败', value: -1 }
            ],
            Orders_ESignStatus_List: [
                { name: '全部', value: 0 },
                { name: '不需要', value: 1 },
                { name: '电子签章订单', value: -1 },
                { name: '待同步', value: 2 },
                { name: '发送失败', value: 3 },
                { name: '海湾签章失败', value: 4 },
                { name: '待客户签署', value: 5 },
                { name: '客户签署完成', value: 6 },
                { name: '客户拒签', value: 7 },
                { name: '逾期未签署', value: 8 },
                { name: '客户签署失败', value: 9 },
                { name: '已撤回', value: 10 }
            ],
            RecoverStatus_opt: [
                { label: '全部合同', value: 0 },
                { label: '不需要回收订单', value: 1 },
                { label: '待回收订单', value: 2 },
                { label: '已回收订单', value: 3 }
            ],
            multipleSelection: [],
        };
    },
    mounted() {
        const e = this.$route.query || '';
        this.getOrdersPayTypes();
        this.onRefresh(e);
        this.$store.dispatch('fetchLocationData');
    },
    methods: {
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getSPCOrders();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getSPCOrders();
        },
        //重置
        onRefresh(e) {
            this.params = {
                Orders_Address_Country: '',
                Orders_Address_District: '',
                Orders_Address_Province: '',
                Orders_Address_City: '',
                date_start: '',
                date_end: '',
                orders_tradetype: '',
                paytype: 0,
                RecoverStatus: 0,
                orders_bpmauditstatus: '',
                Orders_ESignStatus: 0,
                Orders_DiscountCate: '',
                officeman: '',
                keyword: '',
                product_name: this.showQuery?'':this.projectName,
                Orders_SourceERPSN: '',
                addtime: 0,
                orders_auditstatus: -1,
                orders_status: -1,
                Orders_SourceCate: 1
            };

            if (e) {
                if (e.RecoverStatus) {
                    this.params.RecoverStatus = +e.RecoverStatus;
                }
            }
            this.getSPCOrders(true);
        },
        getSPCOrders(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi.order
                .getSPCOrders(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params };
            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        //导出所有
        getPipelineApplysExport(e) {
            if (e == 1) { 
                let id = [];
                id = this.multipleSelection.map((item) => {
                    return item.Orders_ID;
                });
                let json = JSON.stringify(id);
                let loadingInstance = this.$loading(); // 显示 loading
                this.$newsApi.ExportSPCOrders({ json: json }).then((res) => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data);
                    }
                });
            } else {
                let loadingInstance = this.$loading(); // 显示 loading
                this.$newsApi.ExportSPCOrdersAll(this.filteropt()).then((res) => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data, res.data.Resultinfo);
                    }
                });
            }
        },
        handleViewsDetail(row) {
            this.$router.push({
                path: '/contractreturnManagement/details',
                query: {
                    id: row.Orders_ID
                }
            });
        },
        handleClose() {
            this.isdetails = false;
        },
        /*
        获取付款方式
        */
        getOrdersPayTypes() {
            const TradeType = 2;
            const Customer_Type = 0;
            const Customer_IsLimitPay = 0;
            this.$newsApi.order.GetAllPayTypes().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.paytype_opt = res.data.data;
                }
            });
        },
        /*
        选择省
        */
        provinceChange(e) {
            console.log(e, 'eeeee');
            this.cityListopt = [];
            this.params.Orders_Address_City = '';
            this.districtListopt = [];
            this.params.Orders_Address_District = '';
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);
        },
        /*
        选择市
        */
        cityChange(e) {
            console.log(e, 'eeeee');
            this.districtListopt = [];
            this.params.Orders_Address_District = '';
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);
            console.log(this.districtListopt, 'this.districtListoptthis.districtListopt');
        },
        /*
        多选
        */
        handleSelectionChange(val) { },
        getApplyOrder() {
            this.Orders_SN = '';
            this.dialogVisible = true;
        },
        dialogBeforeClose() {
            this.dialogVisible = false;
        },
        onNext() {
            if (this.Orders_SN == '') {
                this.$message({
                    message: 'ERP订单号不能为空',
                    type: 'warning'
                });
                return;
            }

            this.$newsApi.getERPOrdersByERPSN({ Orders_ERPSN: this.Orders_SN }).then((res) => { });
        }
    }
};
</script>
